import $ from "jquery";
(function ($) {
  //* Make sure JS is enabled
  //  document.documentElement.className = "js";

  $(document).ready(function () {
    //* Run 0.25 seconds after document ready for any instances viewable on load
    setTimeout(function () {
      animateObject();
    }, 250);
  });

  $(window).scroll(function () {
    animateObject();
  });

  function animateObject() {
    var object = $(".fadeup");

    $.each(object, function () {
      if (!$(this).hasClass("faded")) {
        var windowHeight = $(window).height(),
          offset = $(this).offset().top,
          top = offset - $(document).scrollTop(),
          percent = Math.floor((top / windowHeight) * 100);

        if (percent < 99) {
          if ($(this).parent().hasClass("pen-slide")) {
            $(
              ".pen-slide[data-slick-index='-1'] .pen-slide-container.fadeup"
            ).addClass("faded");
            setTimeout(function () {
              $(
                ".pen-slide[data-slick-index='0'] .pen-slide-container.fadeup"
              ).addClass("faded");
            }, 250);
            setTimeout(function () {
              $(".pen-slide .pen-slide-container.fadeup").addClass("faded");
            }, 500);
          } else {
            $(this).addClass("faded");
          }

          $(".faded *").each(function () {
            if (!$(this).hasClass("pen-slide-img")) {
              $(this).addClass("fadeup");
            }
          });
        }
      }
    });
  }
})(jQuery);
